import { useMe } from '../../../hooks/useMe';
export const useGetLoginInfo = _ref => {
  let {
    teamKey,
    enableExternalData,
    externalData
  } = _ref;
  const {
    meData,
    meIsLoading
  } = useMe({
    teamKey: teamKey,
    cancelFetch: enableExternalData
  });
  const isLoading = enableExternalData ? (externalData === null || externalData === void 0 ? void 0 : externalData.meIsLoading) || false : meIsLoading;
  const data = enableExternalData ? externalData : meData;
  const {
    nickname,
    facebookPictureUrl,
    googlePictureUrl,
    publicAccountId
  } = data || {};
  const profilePicture = facebookPictureUrl || googlePictureUrl || '';
  const isLogged = !!(data === null || data === void 0 ? void 0 : data.nickname) || !!(data === null || data === void 0 ? void 0 : data.facebookPictureUrl) || !!(data === null || data === void 0 ? void 0 : data.googlePictureUrl);
  let userName = '';
  if (nickname) {
    const maxUserNameLength = 16;
    userName = nickname.length < maxUserNameLength ? nickname : "".concat(nickname.substring(0, maxUserNameLength - 1), "\u2026");
  }
  return {
    isLogged,
    profilePicture,
    userName,
    publicAccountId: publicAccountId || '',
    meIsLoading: isLoading
  };
};